module.exports = __webpack_public_path__ + "static/img/data-analysis.4c827829.png";